import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AbstractProblemForUserApiService } from 'src/app/core/services/abstract/abstract-problem-for-user-api-service';
import * as actions from './actions';

@Injectable()
export class ProblemForUserStoreEffects {
  private problemForUserApiService = inject(AbstractProblemForUserApiService);
  private actions$ = inject(Actions);

  loadRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.LoadRequestAction>(actions.ActionTypes.LOAD_REQUEST),
      switchMap(action =>
        this.problemForUserApiService.getActiveProblems(action.userId).pipe(
          map(items => (items.isSucceeded ? new actions.LoadSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  subscriptionRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.CreateSubscriptionRequestAction>(actions.ActionTypes.CREATE_SUBSCRIPTION_REQUEST),
      switchMap(action =>
        this.problemForUserApiService.subscriptionProblem(action.problemId, action.userId).pipe(
          map(items =>
            items.isSucceeded ? new actions.CreateSubscriptiondSuccessAction(items.result) : new actions.FailureAction(items.errors[0])
          ),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  unSubscriptionRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.DeleteSubscriptionRequestAction>(actions.ActionTypes.DELETE_SUBSCRIPTION_REQUEST),
      switchMap(action =>
        this.problemForUserApiService.unSubscriptionProblem(action.subscriptionId).pipe(
          map(items =>
            items.isSucceeded ? new actions.DeleteSubscriptiondSuccessAction(items.result) : new actions.FailureAction(items.errors[0])
          ),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  lockRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.CreateLockRequestAction>(actions.ActionTypes.CREATE_LOCK_REQUEST),
      switchMap(action =>
        this.problemForUserApiService.lockProblem(action.problemId, action.userId).pipe(
          map(items =>
            items.isSucceeded ? new actions.CreateLockSuccessAction(items.result) : new actions.FailureAction(items.errors[0])
          ),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );
}
